/**
 * 创建人：袁俊双
 * 时间：2019-9-22
 * 描述：鼠标移入,出现消息提示框
 * 更新记录: 
 */
import { Directive, HostListener, ElementRef, Input } from '@angular/core';

/**
 * 鼠标移入,出现消息提示框  SwMouseoverTip
 * 
 * @example <td [SwMouseoverTip]="'111<br>222'">{{data.fileOldname}}</td>
 */
@Directive({
  selector: '[SwMouseoverTip]'
})
export class SwMouseoverTipDirectiveDirective {

  constructor(private el: ElementRef) { }
  tipBox:any

  @Input('SwMouseoverTip') SwMouseoverTipMsg:any;
  
  // @HostListener('mouseover', ['$event']) onmouseover(event) {
  //   event.stopPropagation(); //禁止冒泡
  //   this.tipBox = document.createElement('div')
  //   this.tipBox.innerHTML = this.SwMouseoverTipMsg
  //   this.tipBox.classList.add('mouseoverTip')
  //   this.tipBox.style.position = 'absolute'
  //   document.body.appendChild(this.tipBox)
  //   this.tipBox.style.left = event.target.getBoundingClientRect().right+'px'
  //   this.tipBox.style.top = event.target.getBoundingClientRect().top + document.body.scrollTop + 'px'
  //   //视口的宽度: document.body.clientWidth - 要显示提示消息的元素的右边框距离视口左边的宽度 = 要显示提示消息的元素的右边框距离视口右边的宽度
  //   if((document.body.clientWidth - event.target.getBoundingClientRect().right) < this.tipBox.getBoundingClientRect().width){
  //     this.tipBox.classList.add('leftBox')
  //     this.tipBox.style.left = (event.target.getBoundingClientRect().left - this.tipBox.getBoundingClientRect().width + document.body.scrollLeft)+'px'
  //   }
  // }

  // @HostListener('mouseout', ['$event']) onmouseout(event) {
  //   document.body.removeChild(this.tipBox)
  // }

  @HostListener('mouseover', ['$event']) onmouseover(event) {
    event.stopPropagation(); //禁止冒泡
    this.tipBox = document.createElement('div')
    this.tipBox.innerHTML = this.SwMouseoverTipMsg
    this.tipBox.classList.add('mouseoverTip')
    this.tipBox.style.position = 'fixed'
    document.body.appendChild(this.tipBox)
    var posX = 0,posY = 0;                        //临时变量
    var event = event || window.event;            //标准化事件对象
    if(event.pageX || event.pageY){               //获取鼠标指针的当前坐标值
        posX = event.pageX;
        posY = event.pageY;   
    }else if(event.clientX || event.clientY){    
        posX = event.clientX + document.documentElement.scrollLeft + document.body.scrollLeft;
        posY = event.clientY + document.documentElement.scrollTop + document.body.scrollTop;
    };
    if((document.body.clientWidth - event.target.getBoundingClientRect().right) < this.tipBox.getBoundingClientRect().width){
      this.tipBox.classList.add('leftBox')
      this.tipBox.style.left = (posX - this.tipBox.getBoundingClientRect().width - 10 + document.body.scrollLeft)+'px'
    } else {
      this.tipBox.style.left = (posX + 30) + 'px';             //用鼠标指针的x轴坐标和传入偏移值设置对象x轴坐标

    }
    this.tipBox.style.position = 'absolute';                //定义当前对象为绝对位置
    this.tipBox.style.top = (posY + 10) + 'px';              //用鼠标指针的y轴坐标和传入偏移值设置对象y轴坐标
  }
  @HostListener('mousemove', ['$event']) onmousemove(event) {
    var posX = 0,posY = 0;                        //临时变量
    var event = event || window.event;            //标准化事件对象
    if(event.pageX || event.pageY){               //获取鼠标指针的当前坐标值
        posX = event.pageX;
        posY = event.pageY;   
    }else if(event.clientX || event.clientY){    
        posX = event.clientX + document.documentElement.scrollLeft + document.body.scrollLeft;
        posY = event.clientY + document.documentElement.scrollTop + document.body.scrollTop;
    };
    if((document.body.clientWidth - event.target.getBoundingClientRect().right) < this.tipBox.getBoundingClientRect().width){
      this.tipBox.classList.add('leftBox')
      this.tipBox.style.left = (posX - this.tipBox.getBoundingClientRect().width - 10 + document.body.scrollLeft)+'px'
    } else {
      this.tipBox.style.left = (posX + 30) + 'px';             //用鼠标指针的x轴坐标和传入偏移值设置对象x轴坐标
    }
    this.tipBox.style.position = 'absolute';                //定义当前对象为绝对位置
    this.tipBox.style.top = (posY + 10) + 'px';              //用鼠标指针的y轴坐标和传入偏移值设置对象y轴坐标
  }

  @HostListener('mouseout', ['$event']) onmouseout(event) {
    document.body.removeChild(this.tipBox)
  }
}
